import React, { useState } from 'react';
import { ImageOff } from 'lucide-react';

/**
 * SecureImage : rend une image servie par /api/uploads/* (ou URL absolue) avec
 * un fallback visuel propre en cas d'erreur de chargement.
 *
 * Les routes /api/uploads/* etant publiques, on utilise une balise <img> standard
 * (compatible avec tous les CDN/proxies). Si l'image echoue a charger, on affiche
 * un placeholder "Image indisponible" au lieu d'une icone cassee.
 */
const BACKEND = process.env.REACT_APP_BACKEND_URL;

const SecureImage = ({ src, alt = '', className = '', onClick, ...rest }) => {
  const [hasError, setHasError] = useState(false);

  if (!src || hasError) {
    return (
      <div
        className={`flex flex-col items-center justify-center bg-gray-50 text-gray-400 ${className}`}
        onClick={onClick}
        title="Image indisponible"
        {...rest}
      >
        <ImageOff className="w-5 h-5" />
      </div>
    );
  }

  const fullUrl = src.startsWith('http') ? src : `${BACKEND}${src}`;

  return (
    <img
      src={fullUrl}
      alt={alt}
      className={className}
      onClick={onClick}
      onError={() => setHasError(true)}
      {...rest}
    />
  );
};

export default SecureImage;
